"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionTag = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const css_1 = require("@emotion/css");
const useMediaContext_1 = require("../context/useMediaContext");
const NFTDataContext_1 = require("../context/NFTDataContext");
const Orb_1 = require("../components/Orb");
const CollectionTag = () => {
    const { nft: { data }, } = react_1.useContext(NFTDataContext_1.NFTDataContext);
    const { getStyles } = useMediaContext_1.useMediaContext();
    const getContent = () => {
        return (jsx_runtime_1.jsxs("a", Object.assign({}, getStyles("colectionTagWrapper"), { href: `https://zora.co/collections/${data === null || data === void 0 ? void 0 : data.nft.contract.address}`, target: "_blank", rel: "noreferrer" }, { children: [jsx_runtime_1.jsx("div", Object.assign({}, getStyles("collectionTagIcon"), { children: /* @ts-ignore */ data && "openseaInfo" in data
                        ? jsx_runtime_1.jsx("img", { src: data.openseaInfo.asset_contract.image_url, alt: data.openseaInfo.asset_contract.name }, void 0)
                        : jsx_runtime_1.jsx(Orb_1.Orb, {}, void 0) }), void 0),
                jsx_runtime_1.jsx("span", { children: data && "openseaInfo" in data ? `${data.openseaInfo.asset_contract.name}` : 'Zora' }, void 0)] }), void 0));
    };
    return (jsx_runtime_1.jsx("div", Object.assign({ className: css_1.css `
      position: relative;
      display: flex;
      flex-direction: row;
    ` }, { children: data ? getContent() : '...' }), void 0));
};
exports.CollectionTag = CollectionTag;
